import { render, staticRenderFns } from "./Head2Head.vue?vue&type=template&id=48cfcffa&"
import script from "./Head2Head.vue?vue&type=script&lang=js&"
export * from "./Head2Head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports